module.exports = __webpack_public_path__ + "static/media/about icon2.869d5945.png";